module.exports = __webpack_public_path__ + "static/media/paragraphe1.a2fab666.jpg";